import { CalendarMonth } from '@mui/icons-material'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaCalendarAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'
import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'
import { getDateStatus } from 'utils/helpers'

const SectionSubjectPath: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  
  const [groupCourse, setGroupCourse] = useState(null)

  const { data } = useGET_groupCoursesQuery({page: 1})
  const { data: sessions } = useGET_groupCourseSessionsQuery({ 
    page: 1, 
    page_size: 12, 
    group_course: groupCourse, 
    ordering: 'start_datetime'
  }, { skip: !groupCourse })

  useEffect(() => {
    if (data?.results.length > 0) {
      setGroupCourse(data?.results[0].id ?? null)
    }
  }, [data])


  return (
     <div>
        <div style={{marginBottom: '10px'}}>{t('dashboard.your-learning-path')}</div>
        <div className="workspace-tabs">
            {data?.results?.map((s) => <div key={s.id} className={`workspace-tab orange ${groupCourse==s.id && 'selected'}`}
                onClick={() => {setGroupCourse(s.id)}}
            >
                {s.subject?.title}
            </div>)}    
        </div>
        <div className="workspace-tabs-box" style={{ background: '#FEFAE4', padding: '20px' }}>
          <div className='timeline'>
            {sessions && sessions.results
              .filter(s => !!s.plan?.id)
              .slice(0,3)
              .map(s => <div key={s.id} className={`time-box ${getDateStatus(s.start_datetime)=='today' && 'selected'}`}
                    onClick={() => navigate(`/sessions/view/${s.id}`)}
                  >

                    <div className="time-box-title">
                      <b>{t('goalbank.lesson')} {s.plan?.number}: </b>
                      {s.plan?.title}
                    </div>

                    <div className="time-box-title">
                        <b>{t('common.lesson-objectives')}:</b><br />
                        { s.plan?.learning_objectives?.substring(0,50) }...
                    </div>

                    <div className='time-box-status'>
                      <CalendarMonth sx={{ fontSize: '30px',
                        color: getDateStatus(s.start_datetime) === "today" 
                        ? "#000000" : getDateStatus(s.start_datetime) === "passed" 
                        ? "#A6D966"
                        : "#8FCEF7"
                      }}/>
                      {t(`date-status.${getDateStatus(s.start_datetime)}`)}
                      
                    </div>
                    
             </div>)}
          </div>
        </div>
     </div>
  )
}

export default SectionSubjectPath
